import React from 'react';
import { useParams } from 'react-router';
import FixtureDetailsScreen from '@client/screens/fixtures/shared/FixtureDetailsScreen';

const FixtureBbOutDetailsScreen = () => {
	const { id }: { id?: string | undefined } = useParams();

	const fixtureId = Number(id);

	return (
		<FixtureDetailsScreen
			fixtureId={fixtureId}
		/>
	);
};

export default FixtureBbOutDetailsScreen;
